export const createIdempotencyKey = () => {
  if (window.crypto?.randomUUID) return window.crypto.randomUUID();
  return `offline-${Date.now()}-${Math.random().toString(36).slice(2)}`;
};

// Reuse one key per (bill, method) so a retry after a timeout is deduplicated
// by the server; a different bill or method is a different payment context.
export const getStableIdempotencyKey = (ref, scope) => {
  if (ref.current?.scope !== scope) {
    ref.current = { scope, key: createIdempotencyKey() };
  }
  return ref.current.key;
};
